/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/317-arrow-right2': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M9.707 13.707l5-5a.999.999 0 000-1.414l-5-5a.999.999 0 10-1.414 1.414L11.586 7H2a1 1 0 000 2h9.586l-3.293 3.293a.997.997 0 000 1.414.999.999 0 001.414 0z"/>'
  }
})
